import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {JobEventApiDto, JobExternalCallRegisteredEventDataApiDto} from "../../../api/model/rest";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");

export default class JobExternalCallRegisteredEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data external call registered event data
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobExternalCallRegisteredEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobExternalCallRegisteredEvent {
		const data = JobExternalCallRegisteredEventData.fromJson(json.data as JobExternalCallRegisteredEventDataApiDto);

		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobExternalCallRegisteredEvent(json.id,
			json.jobId,
			JobEventTypeEnum.ExternalCallRegistered,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.Phone;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityAdditionalMessages(): string[] {
		return [this.data.conversationContent];
	}

	getActivityType(): string {
		return `JOB PHONE CALL`;
	}

	getActivityMessage(): string {
		return `Job external call registered`;
	}
}

export class JobExternalCallRegisteredEventData {
	constructor(public readonly conversationContent: string) {}

	public static fromJson(json: JobExternalCallRegisteredEventDataApiDto): JobExternalCallRegisteredEventData {
		return new JobExternalCallRegisteredEventData(json.conversationContent);
	}
}
